import React, { useEffect, useState } from 'react';
import { loadStoreItems } from '../../apis/dumpert';
import { ClickElement } from '../form';
import styles from './ItemsList.css';
import { ItemsList } from './ItemsList';
import { Loading } from '../loading';

const createStoreLink = url => `${url}?${new URLSearchParams({
  utm_source: 'dumpert',
  utm_medium: 'websitetop3',
  utm_content: 'meerwinkel',
}).toString()}`;

export const ItemsListSidebarStoreBlock = ({ numOfItems }) => {

  const [storeItemsList, setStoreItemsList] = useState({ isLoading: true, isError: false, items: [] });

  async function fetchStoreItems() {
    await loadStoreItems()
      .then(response => {
        const { data } = response;
        data.sort((a, b) => a.start_date > b.start_date ? -1 : 1);
        const items = data.map(item => ({
          date: '',
          description: item.description,
          id: item.id,
          media: [],
          nopreroll: false,
          nsfw: false,
          stats: {
            kudos_today: 0,
            kudos_total: 0,
            views_today: 0,
            views_total: 0,
          },
          still: item.image,
          stills: {
            still: item.image,
            ['thumb-medium']: item.image,
          },
          tags: '',
          thumbnail: item.image,
          title: item.title,
          upload_id: '',
          store_data: {
            id: item.id,
            title: item.title,
            image: item.image,
            price: item.price,
            link: createStoreLink(item.link),
            start_date: item.start_date,
            end_date: item.end_date,
            description: item.description,
          },
        }));
        setStoreItemsList({
          isLoading: false,
          items,
        });
      })
      .catch(() => {
        setStoreItemsList({
          isLoading: false,
          isError: true,
          items: [],
        });
      });

  }

  useEffect(() => {
    fetchStoreItems();
  }, []);

  const componentProps = {
    labels: {
      TITLE: 'winkel',
      BUTTON: 'Meer winkel',
    },
    storeUrl: createStoreLink('//dumpertwinkel.nl/v2/shop/'),
  };

  const listProps = {
    items: storeItemsList.items.slice(0, numOfItems),
    isStoreItem: true,
    isSidebar: true,
  };

  const { labels, storeUrl } = componentProps;

  return (
    <>
      {(storeItemsList.isLoading && !storeItemsList.isError) && <Loading whatIsLoading="producten"/>}
      {(!storeItemsList.isLoading && !storeItemsList.isError) && (
        <>
          <div className={styles.itemslist}>
            <h2>{labels.TITLE}</h2>
            <div className={'grid one'}>
              <ItemsList {...listProps} />
            </div>
            <ClickElement
              tertiary
              ElementType='a'
              text={labels.BUTTON}
              href={storeUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{ 'marginBottom': '0' }}
            />
          </div>
          <div className={'spacer'}></div>
        </>
      )}
    </>
  );
};
